import {ModelType, ModelTypeID} from "../../api";
import {AssistantNewChats} from "../assistantNew";
import React from "react";

export const CommunistPartySecretaryChats = () => {
    return <AssistantNewChats modelType={ModelType.COMMUNIST_PARTY_SECRETARY}
                              modelTypeId={ModelTypeID.COMMUNIST_PARTY_SECRETARY}/>;
}
